/**
 * Компонент 3: Lot Markers
 * MVT tiles, circle points, price pills.
 */
(function() {
  'use strict';

  const maplibregl = window.maplibregl;
  const API_BASE = window.location.origin;
  const LOTS_MVT_URL = API_BASE + '/tiles/lots_mvt/{z}/{x}/{y}';
  if (typeof window._selectedLotId === 'undefined') {
    window._selectedLotId = null;
  }

  const _dom = {};
  function cacheDom() {
    const ids = [
      'filter-min-price', 'filter-max-price',
      'ad_type_auction_sale', 'ad_type_auction_rent',
      'ad_type_direct_sale', 'ad_type_lease_transfer', 'ad_type_ips',
      'filter-actual-only',
      'filter-history-from-month', 'filter-history-from-year',
      'filter-history-to-month', 'filter-history-to-year'
    ];
    ids.forEach(function(id) { _dom[id] = document.getElementById(id); });
  }

  function isAuthForFilters() {
    return typeof window.goszemlyaAuth === 'object' &&
           typeof window.goszemlyaAuth.isAuthenticated === 'function' &&
           window.goszemlyaAuth.isAuthenticated();
  }

  function getHistoryValue(dir) {
    const mEl = _dom['filter-history-' + dir + '-month'];
    const yEl = _dom['filter-history-' + dir + '-year'];
    if (!mEl || !yEl) return null;
    const m = mEl.value;
    const y = yEl.value;
    if (!m || !y) return null;
    return y + '-' + m;
  }

  function isHistoricalMode() {
    const actualOnlyEl = _dom['filter-actual-only'];
    return actualOnlyEl ? !actualOnlyEl.checked : false;
  }

  function buildCircleColorExpression() {
    if (isHistoricalMode()) {
      return [
        'case',
        ['==', ['get', 'lot_id'], window._selectedLotId || ''], '#ff0000',
        '#9333ea'
      ];
    }
    return [
      'case',
      ['==', ['get', 'lot_id'], window._selectedLotId || ''], '#ff0000',
      ['==', ['get', 'bidd_form_code'], 'IPS'], '#f97316',
      ['all', ['==', ['get', 'bidd_form_code'], 'EA'], ['==', ['get', 'type_transaction'], 'sale']], '#2563eb',
      ['all', ['==', ['get', 'bidd_form_code'], 'EA'], ['==', ['get', 'type_transaction'], 'rent']], '#16a34a',
      ['==', ['get', 'type_transaction'], 'sale'], '#9333ea',
      ['==', ['get', 'type_transaction'], 'rent'], '#dc2626',
      '#9333ea'
    ];
  }

  function formatPrice(price) {
    const n = Number(price);
    if (!isFinite(n) || n <= 0) return '';
    if (n >= 1000000) {
      return (Math.round(n / 100000) / 10) + ' млн.р.';
    }
    return Math.round(n / 1000) + ' т.р.';
  }

  function getPillColor(props) {
    if (isHistoricalMode()) return '#9333ea';
    const bidd = props.bidd_form_code;
    const trans = props.type_transaction;
    if (bidd === 'IPS') return '#f97316';
    if (bidd === 'EA' && trans === 'sale') return '#2563eb';
    if (bidd === 'EA' && trans === 'rent') return '#16a34a';
    if (trans === 'sale') return '#9333ea';
    if (trans === 'rent') return '#dc2626';
    return '#2563eb';
  }

  // MVT tiles switch between active and historical lots server-side.
  // Ad-type filtering (including IPS) is applied client-side like any other type.
  function buildMvtUrl() {
    const qp = new URLSearchParams();
    const actualOnlyEl = _dom['filter-actual-only'];
    const actualOnly = actualOnlyEl ? actualOnlyEl.checked : true;
    qp.set('actual_only', actualOnly ? 'true' : 'false');
    if (!actualOnly) {
      const from = getHistoryValue('from');
      const to = getHistoryValue('to');
      if (from) qp.set('history_from', from);
      if (to) qp.set('history_to', to);
    }
    // Include IPS lots in the tile only when the IPS filter is enabled.
    // Client-side filtering still decides whether they are actually shown.
    const ipsEl = document.getElementById('ad_type_ips');
    if (ipsEl && ipsEl.checked) {
      qp.set('include_ips', 'true');
    }
    const q = qp.toString();
    return LOTS_MVT_URL + (q ? '?' + q : '');
  }

  // ── Price Pills (simple HTML markers) ──────────────────────────
  const PricePills = {
    map: null,
    pills: new Map(),
    _initialized: false,

    init: function(map) {
      if (this._initialized) return;
      this._initialized = true;
      this.map = map;
      const self = this;
      map.on('moveend', function() { self.update(); });
      map.on('zoomend', function() { self.update(); });
      map.on('sourcedata', function(e) {
        if (e.sourceId === 'lots' && e.isSourceLoaded) self.update();
      });
      window.addEventListener('filter:change', function() { self.update(); });
      this.update();
    },

    update: function() {
      if (!this.map) return;
      // Price pills are not shown in historical mode to avoid cluttering the map
      // with price labels over potentially huge numbers of past lots.
      if (isHistoricalMode()) {
        this.clear();
        return;
      }
      const zoom = this.map.getZoom();
      if (zoom < 8) {
        this.clear();
        return;
      }
      const filterExpr = buildFilterExpression();
      const queryOpts = { sourceLayer: 'lots' };
      if (filterExpr) queryOpts.filter = filterExpr;
      let features = [];
      try {
        features = this.map.querySourceFeatures('lots', queryOpts);
      } catch (e) {
        console.warn('[PricePills] querySourceFeatures failed:', e);
      }
      // deduplicate by lot_id
      const seen = new Map();
      features.forEach(function(f) {
        const lotId = f.properties && f.properties.lot_id;
        if (!lotId) return;
        if (!seen.has(lotId)) seen.set(lotId, f);
      });
      // deduplicate and sort by price ascending so the DOM order is stable
      features = Array.from(seen.values());
      features.sort(function(a, b) {
        return (a.properties.price_min || Infinity) - (b.properties.price_min || Infinity);
      });
      // No artificial limit: every visible lot gets its own price pill.
      const activeIds = new Set();
      features.forEach(function(f) {
        const lotId = String(f.properties.lot_id);
        activeIds.add(lotId);
        if (!this.pills.has(lotId)) {
          this.createPill(f);
        }
      }, this);

      // Always keep a pill for the currently selected / directly-linked lot,
      // even if the MVT tile has not loaded yet or the lot has no point feature.
      this.ensureSelectedPill(activeIds);

      for (const [lotId, marker] of this.pills) {
        if (!activeIds.has(lotId)) {
          marker.remove();
          this.pills.delete(lotId);
        }
      }
    },

    createPill: function(feature) {
      const props = feature.properties;
      const coords = feature.geometry && feature.geometry.coordinates;
      if (!coords || !props || !props.price_min || props.price_min <= 0) return;
      this.createPillForLot({
        lot_id: String(props.lot_id),
        price_min: props.price_min,
        bidd_form_code: props.bidd_form_code,
        type_transaction: props.type_transaction,
        final_lon: coords[0],
        final_lat: coords[1]
      });
    },

    createPillForLot: function(lot, force) {
      if (!lot || !lot.lot_id) return;
      const lotId = String(lot.lot_id);
      const lat = lot.final_lat != null ? Number(lot.final_lat) : (lot.nspd_centroid_lat != null ? Number(lot.nspd_centroid_lat) : null);
      const lon = lot.final_lon != null ? Number(lot.final_lon) : (lot.nspd_centroid_lon != null ? Number(lot.nspd_centroid_lon) : null);
      if (lat == null || lon == null || isNaN(lat) || isNaN(lon)) return;
      if (this.pills.has(lotId)) return;
      if (!force && (!lot.price_min || lot.price_min <= 0)) return;

      const props = {
        price_min: lot.price_min,
        bidd_form_code: lot.bidd_form_code,
        type_transaction: lot.type_transaction
      };

      const el = document.createElement('div');
      el.className = 'price-pill new';
      const label = lot.price_min ? formatPrice(lot.price_min) : (lot.cadastral_number || lotId || 'Участок');
      el.textContent = label;
      el.title = lot.price_min ? formatPrice(lot.price_min) : 'Кадастровый номер: ' + (lot.cadastral_number || lotId);
      el.style.backgroundColor = lot.price_min ? getPillColor(props) : '#ea580c';
      el.style.color = '#fff';
      el.style.boxShadow = '0 3px 10px rgba(0,0,0,0.45), 0 0 0 2px #fff';
      el.dataset.bidd = lot.bidd_form_code || '';
      el.dataset.trans = lot.type_transaction || '';

      el.addEventListener('click', function(ev) {
        ev.stopPropagation();
        ev.preventDefault();
        window.dispatchEvent(new CustomEvent('lot:select', {
          detail: { lotId: lotId, source: 'map', zoomToFit: true }
        }));
      });

      const marker = new maplibregl.Marker({ element: el, anchor: 'bottom', offset: [0, -8] })
        .setLngLat([lon, lat])
        .addTo(this.map);

      this.pills.set(lotId, marker);
    },

    ensureSelectedPill: function(activeIds) {
      const selectedId = window._selectedLotId || '';
      const initialLot = window.__INITIAL_LOT_DATA__;
      const isDirectLotUrl = /^\/lot\/[^/]+$/.test(window.location.pathname);

      let lot = null;
      if (initialLot && String(initialLot.lot_id || '') === String(selectedId)) {
        lot = initialLot;
      }
      if (!lot && selectedId) {
        if (window._allLots && Array.isArray(window._allLots)) {
          lot = window._allLots.find(function(l) { return String(l.lot_id) === String(selectedId); });
        }
      }
      if (!lot && isDirectLotUrl && initialLot) {
        lot = initialLot;
      }
      if (!lot || !lot.lot_id) return;

      const lotId = String(lot.lot_id);
      activeIds.add(lotId);
      if (!this.pills.has(lotId)) {
        this.createPillForLot(lot, true);
      }
    },

    refreshColors: function() {
      const selected = String(window._selectedLotId || '');
      for (const [lotId, marker] of this.pills) {
        const el = marker.getElement();
        if (selected && String(lotId) === selected) {
          el.style.backgroundColor = '#ff0000';
        } else {
          el.style.backgroundColor = getPillColor({ bidd_form_code: el.dataset.bidd, type_transaction: el.dataset.trans });
        }
      }
    },

    clear: function() {
      for (const marker of this.pills.values()) {
        marker.remove();
      }
      this.pills.clear();
    }
  };

  // ── Selected lot marker (always visible, used for direct /lot/:id URLs) ──
  const SelectedLotMarker = {
    marker: null,
    show: function(lot) {
      if (!lot || !lot.lot_id) return;
      const lat = lot.final_lat != null ? Number(lot.final_lat) : (lot.nspd_centroid_lat != null ? Number(lot.nspd_centroid_lat) : null);
      const lon = lot.final_lon != null ? Number(lot.final_lon) : (lot.nspd_centroid_lon != null ? Number(lot.nspd_centroid_lon) : null);
      if (lat == null || lon == null || isNaN(lat) || isNaN(lon)) return;
      this.hide();
      const el = document.createElement('div');
      el.className = 'selected-lot-marker';
      el.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/></svg>';
      el.title = lot.cadastral_number || lot.lot_id;
      this.marker = new maplibregl.Marker({ element: el, anchor: 'bottom', offset: [0, -6] })
        .setLngLat([lon, lat])
        .addTo(window.map);
    },
    hide: function() {
      if (this.marker) {
        this.marker.remove();
        this.marker = null;
      }
    }
  };

  // ── Map layers ─────────────────────────────────────────────────
  // Single circle layer for all ad types. MapLibre's circle-sort-key
  // ensures IPS markers are drawn on top of dense regular lots.
  const LOTS_CIRCLE_LAYER = 'lots-circle';

  function removeMarkerLayers(map) {
    if (map.getLayer(LOTS_CIRCLE_LAYER)) map.removeLayer(LOTS_CIRCLE_LAYER);
    if (map.getSource('lots')) map.removeSource('lots');
    PricePills.clear();
  }

  function addMarkerLayers(map) {
    map.addSource('lots', {
      type: 'vector',
      tiles: [buildMvtUrl()],
      minzoom: 0,
      maxzoom: 14,
      attribution: '',
      generateId: true
    });

    const colorExpr = buildCircleColorExpression();

    map.addLayer({
      id: LOTS_CIRCLE_LAYER,
      type: 'circle',
      source: 'lots',
      'source-layer': 'lots',
      paint: {
        'circle-radius': 5,
        'circle-color': colorExpr,
        'circle-opacity': 0.9,
        'circle-stroke-width': 1.5,
        'circle-stroke-color': '#ffffff'
      }
    });
  }

  function buildFilterExpression() {
    const filters = [];

    // Read filter inputs directly from DOM so the expression always reflects
    // the current checkbox state (e.g. after auth changes or manual toggles).
    const adMap = {
      ad_type_auction_sale: 'auction_sale',
      ad_type_auction_rent: 'auction_rent',
      ad_type_direct_sale: 'direct_sale',
      ad_type_lease_transfer: 'lease_transfer',
      ad_type_ips: 'ips'
    };
    const adTypes = [];
    for (const [id, val] of Object.entries(adMap)) {
      const el = document.getElementById(id);
      if (el && el.checked) adTypes.push(val);
    }

    if (adTypes.length === 0) {
      // Nothing selected: hide all lots.
      filters.push(['literal', false]);
    } else if (adTypes.length < 5) {
      const typeFilters = [];
      for (const t of adTypes) {
        switch (t) {
          case 'auction_sale':
            typeFilters.push(['all', ['==', ['get', 'bidd_form_code'], 'EA'], ['==', ['get', 'type_transaction'], 'sale']]);
            break;
          case 'auction_rent':
            typeFilters.push(['all', ['==', ['get', 'bidd_form_code'], 'EA'], ['==', ['get', 'type_transaction'], 'rent']]);
            break;
          case 'direct_sale':
            typeFilters.push(['all', ['==', ['get', 'type_transaction'], 'sale'], ['!=', ['get', 'bidd_form_code'], 'EA'], ['!=', ['get', 'bidd_form_code'], 'IPS']]);
            break;
          case 'lease_transfer':
            typeFilters.push(['all', ['==', ['get', 'type_transaction'], 'rent'], ['!=', ['get', 'bidd_form_code'], 'EA'], ['!=', ['get', 'bidd_form_code'], 'IPS']]);
            break;
          case 'ips':
            typeFilters.push(['==', ['get', 'bidd_form_code'], 'IPS']);
            break;
        }
      }
      if (typeFilters.length === 1) filters.push(typeFilters[0]);
      else if (typeFilters.length > 1) filters.push(['any'].concat(typeFilters));
    }

    const minPriceEl = document.getElementById('filter-min-price');
    const maxPriceEl = document.getElementById('filter-max-price');
    if (minPriceEl && minPriceEl.value) {
      filters.push(['>=', ['get', 'price_min'], parseFloat(minPriceEl.value)]);
    }
    if (maxPriceEl && maxPriceEl.value) {
      filters.push(['<=', ['get', 'price_min'], parseFloat(maxPriceEl.value)]);
    }

    const puContainer = document.getElementById('filter-permitted-use-container');
    const permittedUseEls = document.querySelectorAll('#filter-permitted-use-container input[type="checkbox"].vri-option:checked');
    const allVriCount = puContainer ? parseInt(puContainer.dataset.vriCount || '0', 10) : 0;
    const puValues = [];
    permittedUseEls.forEach(function(el) { puValues.push(el.value); });
    if (puValues.length > 0 && puValues.length < allVriCount) {
      const hasOther = puValues.indexOf('__other__') !== -1;
      const normalCodes = puValues.filter(function(v) { return v !== '__other__'; });
      const parts = [];
      if (normalCodes.length > 0) {
        const normalFilters = normalCodes.map(function(val) {
          const name = (typeof getVriName === 'function') ? getVriName(val) : '';
          return name ? ['in', name, ['get', 'permitted_use']] : null;
        }).filter(Boolean);
        if (normalFilters.length > 0) {
          parts.push(normalFilters.length === 1 ? normalFilters[0] : ['any'].concat(normalFilters));
        }
      }
      if (hasOther) {
        const knownVriCodes = JSON.parse((puContainer && puContainer.dataset.knownVri) ? puContainer.dataset.knownVri : '[]');
        const knownVriNames = knownVriCodes.map(function(code) {
          return (typeof getVriName === 'function') ? getVriName(code) : '';
        }).filter(Boolean);
        if (knownVriNames.length > 0) {
          parts.push(['all'].concat(knownVriNames.map(function(name) {
            return ['!', ['in', name, ['get', 'permitted_use']]];
          })));
        }
      }
      if (parts.length === 1) filters.push(parts[0]);
      else if (parts.length > 1) filters.push(['any'].concat(parts));
    }

    const regionContainer = document.getElementById('filter-region-container');
    const regionEls = document.querySelectorAll('#filter-region-container input[type="checkbox"].region-option:checked');
    const regions = [];
    regionEls.forEach(function(el) { regions.push(el.value); });
    const allRegionCount = regionContainer ? parseInt(regionContainer.dataset.regionCount || '0', 10) : 0;
    if (regions.length > 0 && regions.length < allRegionCount) {
      filters.push(['match', ['get', 'region_code'], regions, true, false]);
    }

    if (filters.length === 0) return null;
    if (filters.length === 1) return filters[0];
    return ['all'].concat(filters);
  }

  let _filterDebounce = null;
  function applyFilters() {
    clearTimeout(_filterDebounce);
    _filterDebounce = setTimeout(function() {
      const map = window.map;
      if (!map) return;
      const newUrl = buildMvtUrl();
      const source = map.getSource('lots');
      if (source && typeof source.setTiles === 'function') {
        const current = (source.tiles && source.tiles[0]) || '';
        if (current !== newUrl) {
          source.setTiles([newUrl]);
        }
      }
      const filter = buildFilterExpression();
      try {
        if (map.getLayer(LOTS_CIRCLE_LAYER)) {
          map.setFilter(LOTS_CIRCLE_LAYER, filter || null);
          // Circle colors depend on whether we are in historical mode.
          map.setPaintProperty(LOTS_CIRCLE_LAYER, 'circle-color', buildCircleColorExpression());
        }
      } catch (e) {
        console.error('[Markers] Filter error:', e);
      }
      // Keep pills consistent with the current filter and mode.
      PricePills.update();
      PricePills.refreshColors();
    }, 50);
  }

  window.addEventListener('filter:change', applyFilters);

  // Expose the expression builder so the polygon layer can reuse the same logic.
  window.buildLotFilterExpression = buildFilterExpression;

  let _filterListenersBound = false;
  function setupFilterListeners() {
    if (_filterListenersBound) return;
    _filterListenersBound = true;
    const ids = [
      'filter-min-price', 'filter-max-price',
      'ad_type_auction_sale', 'ad_type_auction_rent',
      'ad_type_direct_sale', 'ad_type_lease_transfer', 'ad_type_ips',
      'filter-data-mode',
      'filter-history-from-month', 'filter-history-from-year',
      'filter-history-to-month', 'filter-history-to-year'
    ];
    ids.forEach(function(id) {
      const el = _dom[id];
      if (el) el.addEventListener('change', applyFilters);
    });

    const resetBtn = document.getElementById('lots-filter-reset');
    if (resetBtn) {
      resetBtn.addEventListener('click', function() {
        ['ad_type_auction_sale', 'ad_type_auction_rent', 'ad_type_direct_sale', 'ad_type_lease_transfer'].forEach(function(id) {
          const el = _dom[id];
          if (el) el.checked = true;
        });
        const ipsEl = _dom['ad_type_ips'];
        if (ipsEl) ipsEl.checked = false;
        const dataModeEl = _dom['filter-data-mode'];
        if (dataModeEl) dataModeEl.value = 'actual';
        ['filter-min-price', 'filter-max-price'].forEach(function(id) {
          const el = _dom[id];
          if (el) el.value = '';
        });
        applyFilters();
      });
    }

    window.addEventListener('auth:change', applyFilters);
  }

  function setupInteractions(map) {
    map.on('click', LOTS_CIRCLE_LAYER, function(e) {
      if (window._mapToolsMeasureMode) return;
      if (!e.features || !e.features.length) return;
      const lotId = e.features[0].properties.lot_id;
      window.dispatchEvent(new CustomEvent('lot:select', {
        detail: { lotId: String(lotId), source: 'map', zoomToFit: true }
      }));
    });
    map.on('mouseenter', LOTS_CIRCLE_LAYER, function() {
      map.getCanvas().style.cursor = 'pointer';
    });
    map.on('mouseleave', LOTS_CIRCLE_LAYER, function() {
      map.getCanvas().style.cursor = '';
    });
  }

  function updateSelection(map) {
    if (map.getLayer(LOTS_CIRCLE_LAYER)) {
      map.setPaintProperty(LOTS_CIRCLE_LAYER, 'circle-color', buildCircleColorExpression());
    }
  }

  function initMarkerLayers(map) {
    // Idempotent: only add the source/layers if they are missing.
    // This keeps markers persistent across raster base-layer switches
    // and avoids recreating them on every style event.
    if (!map.getSource('lots')) {
      try {
        addMarkerLayers(map);
      } catch (err) {
        console.error('[Markers] addMarkerLayers failed:', err);
      }
      setupInteractions(map);
    }
    setupFilterListeners();
    // Apply current checkbox state immediately so filters restored from URL/session
    // or the initially-checked IPS box are honored on first load.
    applyFilters();
    PricePills.init(map);
  }

  window.addEventListener('map:ready', function(e) {
    const map = e.detail.map;
    cacheDom();
    initMarkerLayers(map);
  });

  window.addEventListener('map:styleload', function(e) {
    const map = e.detail.map;
    initMarkerLayers(map);
  });

  window.addEventListener('lot:select', function(e) {
    window._selectedLotId = e.detail && e.detail.lotId ? String(e.detail.lotId) : null;
    const map = window.map;
    if (map) updateSelection(map);
    PricePills.update();
    PricePills.refreshColors();
  });

  window.addEventListener('lot:close', function() {
    window._selectedLotId = null;
    const map = window.map;
    if (map) updateSelection(map);
    PricePills.refreshColors();
  });

  async function loadLotsData() {
    try {
      const res = await fetch(API_BASE + '/api/lots/markers');
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const data = await res.json();
      window._allLots = data.items || [];
    } catch (e) {
      console.error('[Markers] Failed to load lots metadata:', e);
    }
  }

  window.addEventListener('map:ready', function() {
    loadLotsData();
  });

  window.addEventListener('lot:focus', function(e) {
    const lotId = e.detail && e.detail.lotId;
    if (!lotId) return;
    window._selectedLotId = String(lotId);
    const map = window.map;
    if (!map) return;
    updateSelection(map);
    PricePills.refreshColors();
    PricePills.update();

    const initialLot = window.__INITIAL_LOT_DATA__;
    if (initialLot && String(initialLot.lot_id) === String(lotId)) {
      SelectedLotMarker.show(initialLot);
      const lat = initialLot.final_lat != null ? Number(initialLot.final_lat) : (initialLot.nspd_centroid_lat != null ? Number(initialLot.nspd_centroid_lat) : null);
      const lon = initialLot.final_lon != null ? Number(initialLot.final_lon) : (initialLot.nspd_centroid_lon != null ? Number(initialLot.nspd_centroid_lon) : null);
      if (lat != null && lon != null) {
        map.flyTo({ center: [lon, lat], zoom: 16, duration: 800, padding: { left: 460 } });
        return;
      }
    }

    if (window._allLots && Array.isArray(window._allLots)) {
      const lot = window._allLots.find(function(l) { return String(l.lot_id) === String(lotId); });
      if (lot) {
        SelectedLotMarker.show(lot);
        const lat = lot.final_lat != null ? Number(lot.final_lat) : (lot.nspd_centroid_lat != null ? Number(lot.nspd_centroid_lat) : null);
        const lon = lot.final_lon != null ? Number(lot.final_lon) : (lot.nspd_centroid_lon != null ? Number(lot.nspd_centroid_lon) : null);
        if (lat != null && lon != null) {
          map.flyTo({ center: [lon, lat], zoom: 16, duration: 800, padding: { left: 460 } });
          return;
        }
      }
    }

    fetch(API_BASE + '/api/lots?limit=1&lot_id=' + encodeURIComponent(lotId))
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        if (data && data.items && data.items[0]) {
          const l = data.items[0];
          SelectedLotMarker.show(l);
          const lat = l.final_lat != null ? Number(l.final_lat) : (l.nspd_centroid_lat != null ? Number(l.nspd_centroid_lat) : null);
          const lon = l.final_lon != null ? Number(l.final_lon) : (l.nspd_centroid_lon != null ? Number(l.nspd_centroid_lon) : null);
          if (lat != null && lon != null) {
            map.flyTo({ center: [lon, lat], zoom: 16, duration: 800, padding: { left: 460 } });
            PricePills.update();
          }
        }
      })
      .catch(function(err) { console.error('[Markers] Focus fetch error:', err); });
  });

  window.addEventListener('lot:close', function() {
    SelectedLotMarker.hide();
  });
})();
